import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seconded',
  templateUrl: './seconded.component.html',
  styleUrls: ['./seconded.component.scss']
})
export class SecondedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
